/**
 * @generated SignedSource<<a14a8bc4603e47f2ec444ab02e05c8fa>>
 * @relayHash cdfdbe4d4bfab1573c61614ab1550d65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a0ded532209b4db9bf5ef85efd72ad6977582c78cdef5afec32c9c2fad17faf3

import type { ConcreteRequest } from 'relay-runtime';
export type ContentStateInput = {
  color?: string | null | undefined;
  id?: AGG$Long | null | undefined;
  name?: string | null | undefined;
  spaceKey?: string | null | undefined;
};
export type SuggestedContentStateCustomizationAreaDeleteContentStateMutation$variables = {
  contentState: ContentStateInput;
};
export type SuggestedContentStateCustomizationAreaDeleteContentStateMutation$data = {
  readonly deleteContentState: {
    readonly color: string;
    readonly id: string | null | undefined;
    readonly name: string;
  } | null | undefined;
};
export type SuggestedContentStateCustomizationAreaDeleteContentStateMutation = {
  response: SuggestedContentStateCustomizationAreaDeleteContentStateMutation$data;
  variables: SuggestedContentStateCustomizationAreaDeleteContentStateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentState"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "stateInput",
        "variableName": "contentState"
      }
    ],
    "concreteType": "ContentState",
    "kind": "LinkedField",
    "name": "deleteContentState",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "color"
      },
      {
        "kind": "ScalarField",
        "name": "id"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SuggestedContentStateCustomizationAreaDeleteContentStateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SuggestedContentStateCustomizationAreaDeleteContentStateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cdfdbe4d4bfab1573c61614ab1550d65",
    "id": "a0ded532209b4db9bf5ef85efd72ad6977582c78cdef5afec32c9c2fad17faf3",
    "metadata": {},
    "name": "SuggestedContentStateCustomizationAreaDeleteContentStateMutation",
    "operationKind": "mutation",
    "text": "mutation SuggestedContentStateCustomizationAreaDeleteContentStateMutation($contentState:ContentStateInput!){deleteContentState(stateInput:$contentState){name,color,id}}"
  }
};
})();

(node as any).hash = "8b6f06ddc6d4f7a1fe5b6c0f41fe87b0";

export default node;
